import style from "./PathObtainCertificate.module.css";
import { useTranslation } from "react-i18next";
import Certificate from "@/ui/certificate/Certificate";

function PathObtainCertificate() {
	const { t } = useTranslation();

	return (
		<div className={style.holder}>
			<div className={style.info}>
				<h3>{t("paths:obtainCertificate.title")}</h3>
				<p>{t("paths:obtainCertificate.text")}</p>
			</div>
			<div className={style.certificateHolder}>
				<Certificate className={style.certificate} size={18} />
			</div>
		</div>
	);
}

export default PathObtainCertificate;
